import React from 'react';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MainNavbar } from 'components';
import { WordListPage, SubscriptionPage, FlashcardPage } from 'pages';
import { BrowserRouter, Route, Routes } from "react-router-dom";

const App = () => {

  return (
    <BrowserRouter>
      <div>
        <MainNavbar />
        <div className="content">
          <h1>Welcome to AutoLexi!</h1>
          <p>Learn by reading</p>
        </div>
        <Routes>
          <Route path="/" element={<FlashcardPage />} />
          <Route path="/wordlist" element={<WordListPage />} />
          <Route path="/account" element={<SubscriptionPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export {App};